/**
 * Checks if the current environment is production
 */
export const isProduction = (): boolean => {
    // Check for production environment
    return process.env.CONTENTFUL_ENVIRONMENT === 'master' &&
    process.env.WEB_DOMAIN === 'www.parcelperform.com'
  }